module.exports = __webpack_public_path__ + "static/fonts/Recta.050baf2.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/Recta.otf
// module id = 333
// module chunks = 0